import { Form } from 'react-bootstrap';
 
const NumericControl = (props = {}) => {
    let state = {
        placeholder:"",
        disable:false,
        id:"",
        className:"",
        hidePlaceholder:false,
        styles:{width:"160px",marginLeft:"10px"},
        initialValue:"0",
        maxValue:props.options.maxValue,
        minValue:props.options.minValue

    };
    if(typeof props.options !== "undefined"){
         state = {...state, ...props.options};
    }
    const handleOnChange = (e) => {
        if(typeof props.SelectionChangeCallback === "function"){
             props.SelectionChangeCallback(e.target.value);
        }
    }
    return(
        <Form.Group><Form.Control style={state.styles} className={state.className} name={state.className} type="number" max={state.maxValue} min={state.minValue} defaultValue={state.initialValue}  onChange={handleOnChange}/> </Form.Group>
    )
}
 
export default NumericControl;